import{a as r}from"./chunk-RAAYCPUM.js";function i(...e){return r(o,e)}function o(e,t){for(let n=e.length-1;n>=0;n--)if(!t(e[n],n,e))return e.slice(0,n+1);return[]}export{i as a};
